import { Logger } from "@zetalabs/core";

const loggerInstance = new Logger();

export { loggerInstance as Logger };
